var sw =  require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator]').each(function() {
    var modelId = $(this).attr('data-sw-model-material-configurator');
    var el = this;
    require(['vue', 'vuex', 'js/store'], function (vue, vuex, vuexStore) {
      /**
       * Vuex Store Module to provide actions and mutations for this component
       */
       // this module is not used in polling and the whole page reloads.
       // We can toggle it off until we properly implement pricing module handling by Vuex

      // vuexStore.registerModule('modelMaterialPricesComponent', {
      //   state: sw.data.vuexStoreState || {}, // add defaults here
      //   namespaced: true,
      //   mutations: {
      //     updateMaterialPricesPolling: function (state, payload) {
      //       state[payload.modelId].showMaterialPrices = payload.showMaterialPrices;
      //     }
      //   },
      //   actions: {
      //     materialPricesPolling: function (context, payload) {
      //       context.commit('updateMaterialPricesPolling', payload);
      //     }
      //   }
      // });

      /**
       * Instantiate Vue root instance
       */
      new vue({
        el: el,
        data: {
          modelId: modelId
        },
        created: function () {
          if (!this.showMaterialPrices) {
            this.pollForMaterialPrices();
          }
        },
        store: vuexStore,
        computed: vuex.mapState({
          modelFileId: function(state) {
            return state[this.modelId].modelFileId
          },
          showMaterialPrices: function (state) {
            return state[this.modelId].showMaterialPrices;
          }
        }),
        methods: {
          pollForMaterialPrices: function () {
            var params = {
              'modelFileId': this.modelFileId
            };
            sw.polling(
              '/model/material-configurator/material-prices-polling',
              function () {
                // This is a temporary solution that will be replaced with Vuex
                // Test: To prevent racing condition between pricing and DB write
                  setTimeout(function(){ window.location.reload(); }, 1000);

                // vuexStore.dispatch('modelMaterialPricesComponent/materialPricesPolling', {
                //   showMaterialPrices: data.showMaterialPrices
                // });
              },
              4000,
              params
            );
          }
        }
      });
    });
  });
};
